import { useEffect } from "react";
import { applySeo } from "./seoHead";

/** Apply page SEO tags + JSON-LD once the data they describe is available. */
export const usePageSeo = (payload) => {
    const key = payload ? JSON.stringify(payload) : "";
    useEffect(() => {
        if (key) applySeo(JSON.parse(key));
    }, [key]);
};

export default usePageSeo;
